module.exports = __webpack_public_path__ + "img/1092995407.0bf64cd3.jpg";